<template>
  <div id="tree">
    <div v-for="(item, index) in data" :key="index" class="tree-group"  :class="{'tree-no-children': !item.son}">
      <div class="tree-row" >
        <div class="tree-row-firstdiv" @click="expandNode(!item.IsExpanded,item)">
          <!-- <i class="el-icon-caret-right el-icon-color" v-if="item.son" v-show="!item.IsExpanded"></i>
          <i class="el-icon-caret-bottom el-icon-color" v-if="item.son" v-show="item.IsExpanded"></i> -->
          <span v-text="item.name" :class="{'tree-children': !item.son}"></span>
        </div>
        <data-tree :data='item.son' :fatherIndex="index" v-if="item.son"></data-tree>
         <!-- v-show="item.IsExpanded" -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dataTree',
  props:{
    data:{
      type: Array,
      default: []
    },
    fatherIndex:{
      type: Number,
      default: 0
    },
    depth:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
    }
  },

  created(){
  },

  methods: {
    expandNode (choice, node) {  // 展开/收起 当前节点
      node.IsExpanded = choice
      if (!choice) {
        this.expandChildrenNode(choice, node.son)
      }
    },
    
    expandChildrenNode (choice, nodes, self) { // 子节点收起
      let _self = self || this
      nodes.forEach((node) => { node.IsExpanded = choice; _self.expandChildrenNode(choice, node.son || [], _self) })
    }
  }
};
</script>

<style lang="less">
.el-icon-color{
  color:#C0C4CC;
}
 #tree {
  .tree-row{
    padding:14px 30px 7px;
    font-size: 26px;
    text-align: left;
  }
  .tree-row-firstdiv{
    height: 32px;
    line-height: 32px;
  }
  .tree-children{
    padding:6px 12px;
    background: #e1e2e6;
    border-radius: 6px;
    font-size: 26px;
    color: #07080c;
  }
  .tree-no-children{
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dataTree.vue